import { createEnv } from "@t3-oss/env-nextjs"
import { z } from "zod"

export const Env = createEnv({
    /*
     * Serverside Environment variables, not available on the client.
     * Will throw if you access these variables on the client.
     */
    server: {
        REVALIDATE_SECRET: z.string().min(1),
    },
    /*
     * Environment variables available on the client (and server).
     *
     * 💡 You'll get type errors if these are not prefixed with NEXT_PUBLIC_.
     */
    client: {
        NEXT_PUBLIC_LEGAL_NAME: z.string().min(1),
        NEXT_PUBLIC_BASE_URL: z.string().min(1),
        NEXT_PUBLIC_MEDUSA_BASE_URL: z.string().min(1),
        NEXT_PUBLIC_WEBSITE_NAME: z.string().min(1),
        NEXT_PUBLIC_PHONE_NUMBER: z.string().min(1),
        NEXT_PUBLIC_WHATSAPP_NUMBER: z.string().min(1),
        NEXT_PUBLIC_ADDRESS: z.string().min(1),
        NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY: z.string().min(1),
        NEXT_PUBLIC_DEFAULT_REGION: z.string().min(1),
        NEXT_PUBLIC_YANDEX_MAP_CONSTRUCTOR_ID: z.string().min(1),
        NEXT_PUBLIC_INN: z.string().optional(),
        NEXT_PUBLIC_OGRN: z.string().optional(),
        NEXT_PUBLIC_EMAIL: z.string().optional(),
        NEXT_PUBLIC_STORAGE_PERIOD: z.string().min(1),

        NEXT_PUBLIC_YANDEX_METRIKA_ID: z.string().min(1).transform(Number),
        NEXT_PUBLIC_LEADBACK_CAMPAIGN: z.string().min(1),
    },
    /*
     * Due to how Next.js bundles environment variables on Edge and Client,
     * we need to manually destructure them to make sure all are included in bundle.
     *
     * 💡 You'll get type errors if not all variables from `server` & `client` are included here.
     */
    runtimeEnv: {
        NEXT_PUBLIC_LEGAL_NAME: process.env.NEXT_PUBLIC_LEGAL_NAME,
        NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
        NEXT_PUBLIC_WEBSITE_NAME: process.env.NEXT_PUBLIC_WEBSITE_NAME,
        NEXT_PUBLIC_PHONE_NUMBER: process.env.NEXT_PUBLIC_PHONE_NUMBER,
        NEXT_PUBLIC_WHATSAPP_NUMBER: process.env.NEXT_PUBLIC_WHATSAPP_NUMBER,
        NEXT_PUBLIC_ADDRESS: process.env.NEXT_PUBLIC_ADDRESS,
        NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY:
            process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY,
        NEXT_PUBLIC_DEFAULT_REGION: process.env.NEXT_PUBLIC_DEFAULT_REGION,
        NEXT_PUBLIC_YANDEX_MAP_CONSTRUCTOR_ID:
            process.env.NEXT_PUBLIC_YANDEX_MAP_CONSTRUCTOR_ID,
        NEXT_PUBLIC_MEDUSA_BASE_URL: process.env.NEXT_PUBLIC_MEDUSA_BASE_URL,
        REVALIDATE_SECRET: process.env.REVALIDATE_SECRET,

        NEXT_PUBLIC_INN: process.env.NEXT_PUBLIC_INN,
        NEXT_PUBLIC_OGRN: process.env.NEXT_PUBLIC_OGRN,
        NEXT_PUBLIC_EMAIL: process.env.NEXT_PUBLIC_EMAIL,
        NEXT_PUBLIC_STORAGE_PERIOD: process.env.NEXT_PUBLIC_STORAGE_PERIOD,

        NEXT_PUBLIC_YANDEX_METRIKA_ID:
            process.env.NEXT_PUBLIC_YANDEX_METRIKA_ID,

        NEXT_PUBLIC_LEADBACK_CAMPAIGN:
            process.env.NEXT_PUBLIC_LEADBACK_CAMPAIGN,
    },
})
